import { textFormatting } from '@yola/ws-sdk';

const {
  wrappersTypes: { decoration },
} = textFormatting.constants;

const ATTRIBUTES_TO_REMOVE = [
  {
    selector: decoration.tagName,
    attributes: ['style'],
  },
];

const removeAttributes = (element, attributes) => {
  attributes.forEach((attribute) => {
    element.removeAttribute(attribute);
  });
};

const removeDynamicAttributes = (node) => {
  ATTRIBUTES_TO_REMOVE.forEach(({ selector, attributes }) => {
    const elements = node.querySelectorAll(selector);

    elements.forEach((element) => removeAttributes(element, attributes));
  });
};

export default removeDynamicAttributes;
